import apiService from '@/state/services/Api'
import isEmpty from 'lodash-es/isEmpty'

const tablets = {
  namespaced: true,
  state:{
    tabletsList:{},
    fetchedTablets:false
  },

  getters: {
    getTabletList(state) {
      
      return state.tabletsList
    },
  },

  mutations: {
    SET_TABLETS(state, payload) {
      state.tabletsList = payload
    },

    SET_FETCHED_TABLETS(state, payload) {
      state.fetchedTablets = payload
    },
    DEACTIVATE_TABLET(state, payload){
      const tablet = state.tabletsList.results.find(tablet=> tablet.uuid === payload.uuid)
      tablet.is_active = false
    }
  },
  actions: {

    async getTablets({ state, commit }) {
      let response = await apiService.get('tablets')
      commit('SET_TABLETS', response)
      return response
    },
    async activateTablet({state,commit}, payload){
      return apiService.post('tablets/', payload)
      .then(data => {return data})
    },
    async deactivateTablet({state, commit},{payload}){
      return apiService.post(`tablets/${payload}/deactivate`).then(data=> { 
        commit('DEACTIVATE_TABLET', data)
        return data})
    },
    async deleteTablet({state,commit}, {payload}){
      return apiService.delete(`tablets/${payload}/`).then(data=>{
        commit('SET_TABLETS', data)
        return data})
    },
    async getInitialTablets({state, commit, getters, dispatch}) {
      let res

      if(!state.fetchedTablets && isEmpty(state.tabletsList)){
        res=await dispatch('getTablets')
        commit('SET_FETCHED_TABLETS',true)
      }
      return getters.getTabletList

    },
    getAssignedTours({state},payload){
      return apiService.get(`tablets/${payload}/tours`)
    },
    reAssignTablet({state, commit}, {tour,payload}) {
      return apiService.put(`tours/${tour.uuid}/assignment`, payload).then(data => data)
    },
  },
}

export default tablets
